module.exports = "<!-- Loading -->\n<div id=\"loading-view\" class=\"loading-screen\">\n  <div class=\"center-loading-img\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/orcas-core/core/templates/core/js/loading.html
// module id = 166
// module chunks = 0